import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from './ui/dialog';
import { Button } from './ui/button';
import { AlertCircle, Mail, Zap } from 'lucide-react';

const ScanLimitDialog = ({ open, onOpenChange, scansUsed, maxScans, contactEmail }) => {
  const navigate = useNavigate();
  
  const handleContactUs = () => {
    window.location.href = `mailto:${contactEmail}?subject=Request to Increase Scan Limit&body=Hello,%0D%0A%0D%0AI have used all my ${maxScans} scans (${scansUsed}/${maxScans}) and would like to request an increase.%0D%0A%0D%0AThank you!`;
  };
  
  const handleUpgrade = () => {
    onOpenChange(false);
    navigate('/pricing');
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="flex items-center justify-center w-16 h-16 mx-auto mb-4 bg-orange-100 rounded-full">
            <AlertCircle className="w-8 h-8 text-orange-600" />
          </div>
          <DialogTitle className="text-center text-xl font-bold">
            Scan Limit Reached
          </DialogTitle>
          <DialogDescription className="text-center space-y-4 pt-4">
            <p className="text-base text-gray-700">
              You have used all <span className="font-bold text-orange-600">{maxScans} scans</span> available to your account.
            </p>
            <p className="text-sm text-gray-600">
              Scans used: <span className="font-semibold">{scansUsed} / {maxScans}</span>
            </p>
            <div className="w-full bg-gray-200 rounded-full h-3 overflow-hidden">
              <div 
                className="bg-gradient-to-r from-orange-500 to-pink-500 h-full transition-all"
                style={{ width: `${(scansUsed / maxScans) * 100}%` }}
              />
            </div>
            <div className="bg-gradient-to-r from-amber-50 to-pink-50 border border-amber-200 rounded-lg p-4 mt-4">
              <p className="text-sm font-semibold text-gray-900 mb-2">
                🎉 Upgrade to Pro or Business Plan
              </p>
              <p className="text-xs text-gray-700 mb-3">
                Get unlimited physical card scans, unlimited virtual cards, unlimited deals, and more!
              </p>
              <Button
                onClick={handleUpgrade}
                className="w-full bg-gradient-to-r from-amber-600 to-pink-600 hover:from-amber-700 hover:to-pink-700 text-white"
                size="sm"
              >
                <Zap className="w-4 h-4 mr-2" />
                View Pricing Plans
              </Button>
            </div>
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-3 mt-6">
          <Button
            onClick={() => onOpenChange(false)}
            variant="outline"
            className="w-full"
          >
            Close
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ScanLimitDialog;
